import "./Dashbord.css";
import React, { useState, useEffect } from "react";
import CardsCourses from "../../../Component/CardsCourses/CardsCourses";
import CardsAdmin from "../../../Component/CardsAdmin/CardsAdmin";
import CardsProfsActifs from "../../../Component/CardsProfsActifs/CardsProfsActifs";
import { ImUserTie } from "react-icons/im";
import { GiBookmarklet } from "react-icons/gi";
import { FaUserGraduate } from "react-icons/fa";
import { Card, Col, ListGroup, Row, Form } from "react-bootstrap";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "../../../Firebase";
import { Link } from "react-router-dom";
import prof from "../../../Assets/prof.jpg"
import etudiant from "../../../Assets/etudiant.jpg"
import cours from "../../../Assets/cours.jpg"
import Loader from "../../../Component/Loader/Loader"


import {
  COURS_ADMIN_NAVIGATION,
  USERS_ADMIN_NAVIGATION,
} from "../../../Routes/NAVIGATION_PATH";

function Dashbord() {
  const [allProf, setAllProf] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [allCours, setAllCours] = useState([]);
  const [nmbrProfs, setNmbrProfs] = useState([]);
  const [nmbrCours, setNmbrCours] = useState([]);
  const [myProfs, setMyProfs] = useState([]);
  const [myStudent, setMyStudent] = useState([]);
  const [myCours, setMyCours] = useState([]);
  const [isLoading, setIsLoading] = useState(true)

  const reftab = query(collection(db, "users"));
  useEffect(() => {
    setTimeout(() => {
      getUsers();
      setIsLoading(false);
    }, 1000)
  }, []);
  const reftabCours = query(collection(db, "cours"));

  const getUsers = () => {
    onSnapshot(reftab, (item) => {
      const currentUserId = sessionStorage.getItem("user_id");
      const data = [];
      item.forEach((i) => {
        data.push({ ...i.data(), id: i.id });
      });

      setAllProf(data.filter((elts) => elts.user_type === "prof"));
      setNmbrProfs(
        data.filter(
          (elts) => elts.user_type === "prof" && elts.admin_id === currentUserId
        )
      );
      setMyProfs(
        data.filter(
          (elts) =>
            elts.user_type === "prof" &&
            elts.admin_id === currentUserId &&
            elts.isArchived === false
        )
      );
      setAllStudents(data.filter((elts) => elts.user_type === "etudiant"));
      setMyStudent(
        data.filter(
          (elts) =>
            elts.user_type === "etudiant" && elts.admin_id === currentUserId
        )
      );
    });
    onSnapshot(reftabCours, (item) => {
      const currentUserId = sessionStorage.getItem("user_id");
      const data = [];
      item.forEach((i) => {
        data.push({ ...i.data(), id: i.id });
      });

      setAllCours(data);
      setNmbrCours(
        data.filter(
          (elts) =>
            (elts.admin_id === currentUserId && elts.isArchived === false) ||
            (elts.created_by === currentUserId && elts.isArchived === false)
        )
      );
      setMyCours(
        data.filter(
          (elts) =>
            (elts.admin_id === currentUserId && elts.isApproved == true) ||
            (elts.created_by === currentUserId && elts.isApproved == true)
        )
      );
    });
  };
  const cousrs = myCours.sort((a, b) => b.created_on.seconds - a.created_on.seconds)

  const my5cours = cousrs.slice(0, 5);
  const my5profs = myProfs.slice(0, 6);
  const cardData = [
    {
      titre: "Professeurs",
      text: "Professeurs",
      icon: <ImUserTie />,
      total: allProf.length,
      couleur: "red",
      nombre: nmbrProfs.length,
      photo: prof
    },
    {
      titre: "cours",
      text: "cours",
      icon: <GiBookmarklet />,
      total: allCours.length,
      couleur: "blue",
      nombre: nmbrCours.length,
      photo: cours
    },
    {
      titre: "Etudiants",
      text: "Etudiants",
      icon: <FaUserGraduate />,
      total: allStudents.length,
      couleur: "green",
      nombre: myStudent.length,
      photo: etudiant
    },
  ];

  // console.log(myCours.map((item)=>{return (item.created_on.seconds)}));
  // const tab =[76,1,2,3,4];
  // console.log(tab.sort().reverse()) 
  // console.log(myCours.sort((a, b) => b.created_on.seconds - a.created_on.seconds));

  return (
    <>
      {
        isLoading ? <Loader /> :
          <div id="dasboardAdmin" className="container-fluid px-4">
            <h3 className="pt-2 ">
              DASHBOARD
              <hr />
            </h3>
            <div className="">
              <Row className="py-1 ">
                {cardData.map(
                  ({ titre, text, icon, nombre, couleur, total, photo }, index) => (
                    <Col className="px-2 " md={4} key={index}>
                      <CardsAdmin
                        titre={titre}
                        icon={icon}
                        nombre={nombre}
                        text={text}
                        couleur={couleur}
                        total={total}
                        className="pe-2"
                        photo={photo}
                      />
                    </Col>
                  )
                )}
              </Row>
            </div>
            <div className=" py-3">
              <Row>
                <Col lg={6} className="px-0 pt-3">
                  <Card>
                    <Card.Title className="d-flex justify-content-between pt-3 px-3">
                      <h4>Professeurs actifs</h4>
                      <Link to={USERS_ADMIN_NAVIGATION} className="btn btn132">
                        Voir plus
                      </Link>
                    </Card.Title>
                    <ListGroup className="list-group-flush">
                      {my5profs.map(
                        (
                          { domaine, prenom, nom, isArchived, photo, id },
                          index
                        ) => (
                          <CardsProfsActifs
                            key={index}
                            domaine={domaine}
                            prenom={prenom}
                            nom={nom}
                            isArchived={isArchived}
                            id={id}
                            photo={photo}
                          />
                        )
                      )}
                    </ListGroup>
                  </Card>
                </Col>
                <Col lg={6} className="px-0 ps-md-2 pt-md-3">
                  <Card>
                    <Card.Title className="d-flex justify-content-between pt-3 px-3">
                      <h4>Cours recents</h4>
                      <Link to={COURS_ADMIN_NAVIGATION} className="btn btn132 ">
                        Voir plus
                      </Link>
                    </Card.Title>
                    <ListGroup className="container list-group-flush">
                      {my5cours.map(
                        (
                          {
                            id,
                            description,
                            infoUser,
                            isApproved,
                            isArchived,
                            domaine,
                            titre_cours,
                          },
                          index
                        ) => (
                          <CardsCourses
                            id={id}
                            key={index}
                            titre_cours={titre_cours}
                            domaine={domaine}
                            infoUser={infoUser}
                            isApproved={isApproved}
                            isArchived={isArchived}
                          />
                        )
                      )}
                    </ListGroup>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
      }
    </>
  );
}

export default Dashbord;
